import { createFileRoute } from '@tanstack/react-router';
import { parseLotsSearch, type LotsSearch } from '@/features/stock/lots-search';
import { LotsPage } from '@/features/stock/lots-page';

export const Route = createFileRoute('/_app/stock/lots/')({
  // the search text, the state chip and the two dropdowns live in the URL, so a
  // filtered lot list can be pasted to the other partner (§3.1)
  validateSearch: (s: Record<string, unknown>): LotsSearch => parseLotsSearch(s),
  component: function Lots() {
    return <LotsPage search={Route.useSearch()} />;
  },
});
